import { useSelector } from 'react-redux';
import { useState } from 'react';
import { getWhatsChanged } from 'helpers/credit_info';
import { isObj } from 'helpers/objectHelpers';
import {
  getLastSeenCreditReport,
  setLastSeenCreditReport,
} from 'helpers/localstorage';
import { formatAsFull, getFirstOfNextMonth } from 'helpers/dateHelper';
import { useHistory } from 'react-router-dom';
import { isPremium } from 'helpers/userHelper';
import { useEventHandler } from 'hook/event.hook';
import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import { useSubscriptionLandingUrl } from './subscriptionLandingUrl.hook';

export const useWhatsChanged = () => {
  const { creditInfo, userInfo } = useSelector(state => ({
    creditInfo: state.creditInfo.creditInfo,
    userInfo: state.userInfo.userInfo,
  }));
  const history = useHistory();
  const isLoaded = isObj(creditInfo);
  const lastSeenReportTimestamp = getLastSeenCreditReport();
  const newUser = isLoaded && creditInfo.trends.creditScores.length <= 1;
  const { subscriptionLandingUrl } = useSubscriptionLandingUrl();

  const isUpdated =
    isLoaded && !newUser
      ? lastSeenReportTimestamp !== creditInfo.reportPulledDate
      : false;

  const eventHandler = useEventHandler();
  // isupdatedstate is used to force a re-render when localstorage is being updated. It is not useful
  const [isUpdatedState, setIsUpdated] = useState(false);
  const [isShowReport, setIsShowReport] = useState(isUpdated);

  const toggleReport = () => {
    eventHandler(CLICK, {
      'Click Type': 'View Current Report',
    });
    setIsShowReport(!isShowReport);
  };

  // Not logged in!
  if (!isObj(creditInfo)) return { anythingChanged: false };

  const fullWhatsChanged = getWhatsChanged(creditInfo);
  const metaChanged =
    fullWhatsChanged.creditScore.difference !== 0 ||
    fullWhatsChanged.negativeMarks.difference !== 0 ||
    fullWhatsChanged.creditUsage.difference !== 0 ||
    fullWhatsChanged.creditLimit.difference !== 0 ||
    fullWhatsChanged.creditAge.difference !== 0 ||
    fullWhatsChanged.creditInquiries.difference !== 0;

  const sawThisCreditReport = () => {
    if (isUpdatedState || !isUpdatedState) {
      setLastSeenCreditReport(creditInfo.reportPulledDate);
      setIsUpdated(true);
    }
  };

  const onRefreshClick = () => {
    eventHandler(CLICK, {
      'Click Type': 'Refresh Current Report',
    });
    history.push(subscriptionLandingUrl);
  };

  const isPremiumUser = isPremium(userInfo);

  return {
    isUpdated: isUpdated && metaChanged,
    nextReportDate: formatAsFull(
      getFirstOfNextMonth(creditInfo.reportPulledDate),
    ),
    hideReportCompletely:
      newUser || !fullWhatsChanged.timestampForLastFullRefresh,
    isShowReport,
    toggleReport,
    ...fullWhatsChanged,
    sawThisCreditReport,
    showRefreshIcon: isShowReport && !isPremiumUser,
    onRefreshClick,
  };
};
